import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
    GetApiAdapter({ commit }, id) {
        return new Promise(resolve => {
            axios({
                url: "/api_adapter/" + id,
                method: "GET"
            }).then(res => {
                resolve(res.data.payload);
            });
        });
    },
    GetApiAdapterList({ commit }, list) {
        return new Promise(resolve => {
            axios({
                url: "/api_adapter/list",
                params: {
                    per_page: list.perPage
                },
                method: "GET"
            }).then(res => {
                resolve(res.data.payload);
            });
        });
    },
};

// mutations
const mutations = {
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
